// components/portal/panelButton.ts
//
// The one button skin for the Source right bar. It had three: a rainbow gradient for Enrich, a
// dark outline for Flag, and a lighter outline for the doctrine. Three weights of emphasis on a
// panel where nothing is more important than anything else, which just read as inconsistency.
// Drawn as ChatGPT's secondary pill (owner, 2026-09-28): round, the Launch bar's #212121 surface.
export const PANEL_BUTTON =
  'flex h-9 w-full items-center justify-center gap-2 rounded-full border border-[#262626] ' +
  'bg-[#212121] font-medium text-[#E5E5E5] transition-colors hover:bg-[#2A2A2A] hover:text-white ' +
  'disabled:opacity-40 disabled:hover:bg-[#212121]';

/** A native <select> as a round pill on the same surface. The chevron is drawn, not native: Chrome
 *  pins its own arrow to the border edge whatever the padding, which put it on the pill's rim. */
export const PILL_SELECT_STYLE = {
  height: 36, borderRadius: 9999, padding: '0 38px 0 14px', fontSize: 13, color: '#E5E5E5',
  border: '1px solid #262626', backgroundColor: '#212121', appearance: 'none', WebkitAppearance: 'none',
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%238E8E8E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`,
  backgroundRepeat: 'no-repeat', backgroundPosition: 'right 14px center',
} as const;

/** Pinned inline because globals.css forces every button to 12px, beating any text-[..] utility. */
export const PANEL_BUTTON_FONT_SIZE = 13;
